import { render, staticRenderFns } from "./ioc-input-edit.vue?vue&type=template&id=03cfab82&scoped=true&"
import script from "./ioc-input-edit.vue?vue&type=script&lang=js&"
export * from "./ioc-input-edit.vue?vue&type=script&lang=js&"
import style0 from "./ioc-input-edit.vue?vue&type=style&index=0&id=03cfab82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cfab82",
  null
  
)

export default component.exports